import {
  combineReducers,
  ReducersMapObject,
  Store,
  StoreEnhancer,
} from 'redux';
import { configureStore } from '@reduxjs/toolkit';

export function createStoreManager({
  reducersMapObj,
  enhancers,
  devTools,
}: {
  reducersMapObj: ReducersMapObject;
  enhancers: StoreEnhancer[];
  devTools?: boolean;
}): {
  store: Store;
  injectReducer: (asyncReducers: ReducersMapObject) => void;
} {
  // Use noop reducer if there's no initial reducer because combineReducer will complain
  // if given empty object
  const store =
    Object.keys(reducersMapObj).length === 0
      ? configureStore({
          reducer: state => state,
          enhancers,
          devTools,
        })
      : configureStore({
          reducer: reducersMapObj,
          enhancers,
          devTools,
        });

  const injectReducer = (asyncReducers: ReducersMapObject) => {
    Object.keys(asyncReducers).forEach(key => {
      reducersMapObj[key] = asyncReducers[key];
    });

    store.replaceReducer(combineReducers(reducersMapObj));
  };

  return {
    store,
    injectReducer,
  };
}
